import type { ITeacherInfo } from '@/Module/Teacher/Model/DataModel/ITeacherListByCategory';

export const preparePersonNameFamily = (teacher: ITeacherInfo) => {
  return `${teacher?.name ?? ''} ${teacher?.family ?? ''}`;
};
